import { render, staticRenderFns } from "./IFBalanceSheet.vue?vue&type=template&id=60c090b8"
import script from "./IFBalanceSheet.vue?vue&type=script&lang=js"
export * from "./IFBalanceSheet.vue?vue&type=script&lang=js"
import style0 from "./IFBalanceSheet.vue?vue&type=style&index=0&id=60c090b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports